<template>
<div class="order-list">
    <div :class="{'bg-head-nav': true, 'bg-head-h187': isBgHeaderH187}"></div>
    <div class="area-1290 order-list-main">
        <div class="controller-container">
            <div class="controller-content">
                <el-radio-group @change="getOrderListByCheckStatus" class="" v-model="checkStatusRadio">
                    <el-radio :label="0">未审核</el-radio>
                    <el-radio class="radio-last" :label="1">已审核</el-radio>
                </el-radio-group>
                <el-cascader class="action-select-inventory" placeholder="选择加油站仓库" :filterable="true" :clearable="true" :options="twoLevelInventoryArr" v-model="twoLevelInventory" @change="selectTwoLevelInventory">
                </el-cascader>
                <el-button v-if="checkStatusRadio" class="action-select-inventory" @click="downloadContracts">选择下载合同</el-button>
                <el-button class="action-select-inventory" @click="uploadFile">上传</el-button>
                <el-button class="action-select-inventory" @click="downloadTemplate">下载模板</el-button>
                <el-button v-if="show" class="action-select-inventory" @click="downloadErpTable">生成ERP表</el-button>
            </div>
        </div>
        <div class="table-container">
            <span v-if="checkStatusRadio" class="table-select-all" >全选</span>
            <el-table @selection-change="selectAllOrder" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" :data="tableData" tooltip-effect="dark" style="width: 100%">
                <el-table-column v-if="checkStatusRadio" type="selection" width="120">
                </el-table-column>
                <el-table-column prop="create_by" label="订货单位" align="center" min-width="23%">
                </el-table-column>
                <el-table-column prop="order_id" label="订单号" align="center" min-width="23%">
                </el-table-column>
                <el-table-column prop="status" label="审核状态" align="center" min-width="15%">
                </el-table-column>
                <el-table-column prop="create_time" label="日期" align="center" min-width="23%">
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="15%">
                    <template slot-scope="scope">
                        <span v-if="userTypeNum == 0 && scope.row.order_type_num == 1">
                            <el-button type="text" v-if="!scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'check')">进入审核</el-button>
                            <el-button type="text" v-if="scope.row.is_check && scope.row.is_can_download" size="small" @click="downloadContract(scope.row.id)">下载合同</el-button>
                            <el-button type="text" v-if="scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'look')">查看详情</el-button>
                        </span>
                        <span v-if="userTypeNum == 0 && scope.row.order_type_num == 0">
                            <el-button type="text" size="small" @click="findOrderDetail(scope.row.id, 'look')">查看详情</el-button>
                        </span>
                        <span v-if="userTypeNum == 1">
                            <el-button type="text" v-if="!scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'check')">进入审核</el-button>
                            <el-button type="text" v-if="scope.row.is_check && scope.row.is_can_download" size="small" @click="downloadContract(scope.row.id, 'look')">下载合同</el-button>
                            <el-button type="text" v-if="scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'look')">查看详情</el-button>
                        </span>
                        <span v-if="userTypeNum == 3">
                            <el-button type="text" v-if="!scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'check')">进入审核</el-button>
                            <el-button type="text" v-if="scope.row.is_check && scope.row.is_can_download" size="small" @click="downloadContract(scope.row.id, 'look')">下载合同</el-button>
                            <el-button type="text" v-if="scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'look')">查看详情</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    <el-dialog title="上传表格" :visible.sync="dialogFormVisible">
        <el-form >
            <el-form-item label="" :label-width="formLabelWidth">
                <!-- https://xarh.sprucesmart.com/api/v1/create_station_order -->
                <el-upload
                    ref="upload"
                    class="upload-demo"
                    action="https://xarh.sprucesmart.com/api/v1/create_station_order"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :limit="1"
                    name="order_excel"
                    :auto-upload="false"
                    :on-error="upLoadFileFail"
                    :on-success="upLoadFileSuccess"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitUpload">上传服务器</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';
import Tool from '../../assets/js/Tool.js';
import Cookie from 'js-cookie';
export default {
    data() {
        return {
            isHide: true,
            isBgHeaderH187: false,
            checkStatusRadio: 0,
            style: '',
            tableData: [],
            currentWarehouse_id: '',
            oneLevelInventoryArr: [],
            twoLevelInventoryArr: [],
            oneLevelInventory: [],
            twoLevelInventory: [],
            fileList: [],
            orderIdArr: [],
            dialogFormVisible: false,
            formLabelWidth: "120px",
            show: false
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created() {
        this.init()
    },
    methods: {
        changeTableHeaderStyle({row, rowIndex}) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle ({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 4) {
                if(row.status_num == -1) {
                    return 'color: #FF3333;'
                }
                else if(row.status_num == 0) {
                    return 'color: #29bd7f;'
                }
                else if(row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        async init() {
            let resData = await this.getInventoryStructure();
            console.log('inventoryStructure: ', resData);
            this.twoLevelInventoryArr = resData.data;
            this.tableData = await this.getUnauditedOrderList('default_station_order?user_id=' + this.user.id)
        },
        // 手动上传文件到服务器
        submitUpload() {
            console.log('手动上传文件到服务器')
            this.$refs.upload.submit();
        },
        upLoadFileFail(response, file, fileList) {
            console.log('response: ', response)
            console.log('file: ', file)
            console.log('fileList: ', fileList)
            this.dialogFormVisible = false;
            this.$message({
                type: 'success',
                message: '上传文件失败!'
            });
        },
        // 上传文件成功
        async upLoadFileSuccess(response, file, fileList) {
            console.log('response: ', response)
            console.log('file: ', file)
            console.log('fileList: ', fileList)
            console.log('上传文件成功')
            this.dialogFormVisible = false;
            this.fileList = [];
            if(response.status == 1) {
                this.$message({
                    type: 'success',
                    message: response.msg
                });
            }
            else {
                this.$message({
                    type: 'error',
                    message: response.msg
                });
            }

            this.tableData = await this.getUnauditedOrderList('default_station_order?user_id=' + this.user.id)
        },
        handleRemove(file, fileList) {
            console.log('删除文件')
            console.log(file, fileList);
        },
        handleExceed(files, fileList) {
            console.log('handleExceed')
            // `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
            this.$message.warning(`当前限制选择 1 个文件`);
        },
        handlePreview(file) {
            console.log('handlePreview')
            console.log(file);
        },
        selectAllOrder(val) {
            console.log('选中的item： ', val);
            if(val.length == 0) {
                this.orderIdArr = [];
            }
            else {
                this.orderIdArr = [];
                val.forEach(item => {
                    this.orderIdArr.push(item.id)
                });
            }
            console.log('orderIdArr: ', this.orderIdArr);
        },
        downloadContracts() {
            console.log('downloadContracts')
            if(this.orderIdArr.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '未选择要打印合同的订单！'
                })
                return;
            }
            window.open('https://xarh.sprucesmart.com/api/v1/print_contract?order_list=' + JSON.stringify(this.orderIdArr) + '&spl_token=' + Cookie.get('xian-spl-token') + '&oil_type=1','_blank');
        },
        uploadFile() {
            this.dialogFormVisible = true;
        },
        downloadTemplate() {
            window.location.href = 'http://xarh.sprucesmart.com/media/order_excel/template/template.xlsx';
        },
        downloadContract(oid) {
            console.log('downloadContract')
            let orderArr = [oid];
            window.open('https://xarh.sprucesmart.com/api/v1/print_contract?order_list=' + JSON.stringify(orderArr) + '&spl_token=' + Cookie.get('xian-spl-token') + '&oil_type=1','_blank');
        },
        // 下载生成Erp表
        downloadErpTable() {
            console.log('111')
            window.location.href = 'https://xarh.sprucesmart.com/api/v1/erp_station_order_excel/?oid_list='+ JSON.stringify(this.orderIdArr);
        },
        async getUnauditedOrderList(url) {
            let orderlist = await this.axios.get(url);
            return orderlist.data.data;
        },
        async getInventoryStructure() {
            let requestConfig = {
                url: 'station_list?user_id=' + this.user.id,
                method: 'get'
            }
            let res = await this.axios(requestConfig);
            return res.data;
        },
        getOrderListData(station_id, is_check) {
            this.axios.get('station_order_list', {
                params: {
                    is_check: is_check,
                    station_id: station_id
                }
            })
            .then(res => {
                this.tableData = res.data.data;
            })
        },
        async getOrderListByCheckStatus() {
            // 如果选中状态为1时为审核
            if (this.checkStatusRadio === 1) {
                this.show = true
            } else {
                this.show = false
            }
            if(this.currentWarehouse_id == '') {
                this.tableData = await this.getUnauditedOrderList('default_station_order?user_id=' + this.user.id + '&style='+this.checkStatusRadio);
                return;
            }
            this.getOrderListData(this.currentWarehouse_id, this.checkStatusRadio);
        },
        // 选择下级仓库结构
        selectOneLevelInventory() {
            this.currentWarehouse_id = this.oneLevelInventory[0];
            this.style = 1;
            this.getOrderListData(this.currentWarehouse_id, this.checkStatusRadio)
        },
        // 选择下2级仓库结构
        selectTwoLevelInventory() {
            if(this.twoLevelInventory.length == 1) {
                this.currentWarehouse_id = this.twoLevelInventory[0];
            }
            else if(this.twoLevelInventory.length == 2) {
                this.currentWarehouse_id = this.twoLevelInventory[1];
            }
            this.style = 2;
            this.getOrderListData(this.currentWarehouse_id, this.checkStatusRadio)

        },
        findOrderDetail(orderId, type) {
            if (type == 'look') {
                let userStr = JSON.stringify(this.user);
                console.log('userStr: ', userStr);
                let routeData = this.$router.resolve({
                    'name': 'orderdetaillook',
                    'query': {
                        oid: orderId,
                        user: userStr,
                        isStation: 'yes'
                    }
                })
                window.open(routeData.href, '_blank');
            } else {
                let userStr = JSON.stringify(this.user);
                console.log('userStr: ', userStr);
                let routeData = this.$router.resolve({
                    'name': 'orderdetailcheck',
                    'query': {
                        oid: orderId,
                        user: userStr,
                        isStation: 'yes'
                    }
                })
                window.open(routeData.href, '_blank');
            }
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.order-list-main {
    position: relative;
    top: -63px;
    background-color: transparent;
}

.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 133px;
}

.action-select-first {
    margin-left: 0px;
}

.table-container {
    position: relative;
}

.table-select-all {

    position: absolute;
    left: 55px;
    top: 13px;
    color: #888;
    z-index: 100;
}

.bg-head-nav {
    background-color: #d2f5e8;
    height: 64px;
}

.bg-head-h187 {
    height: 187px;
}

.radio-last {
    /* margin-left: 15px; */
}
</style>



// WEBPACK FOOTER //
// src/pages/orderManage/FeiYouOrderList.vue